"use client";
import { Eye, EyeOff } from "lucide-react";
import type React from "react";
import { useState } from "react";
import { Input } from "../input";

const PasswordInput = ({
  ref,
  ...props
}: React.ComponentProps<typeof Input> & {
  ref?: React.RefObject<HTMLInputElement | null>;
}) => {
  const { id, label, status, message, placeholder, ...rest } = props;
  const [show, setShow] = useState(false);

  const buttonClassName = label
    ? "absolute right-3 top-1/2 -translate-y-1/2 mt-[12px] flex items-center justify-center text-gray-500"
    : "absolute right-3 top-1/2 -translate-y-1/2 mt-[-10px] flex items-center justify-center text-gray-500";

  return (
    <div className="relative w-full">
      <Input
        classNameInput="w-full px-4 py-2 pr-10"
        ref={ref}
        {...rest}
        hasIcon={false}
        id={id}
        label={label}
        message={message}
        name={id || ""}
        placeholder={placeholder}
        status={status}
        type={show ? "text" : "password"}
      />
      <button
        className={buttonClassName}
        onClick={() => setShow((prev) => !prev)}
        type="button"
      >
        {show ? <EyeOff size={25} /> : <Eye size={25} />}
      </button>
    </div>
  );
};

PasswordInput.displayName = "PasswordInput";

export { PasswordInput };

/*
'use client';
import React, { useState } from 'react';
import { Input } from '../input';
import { Eye, EyeOff } from 'lucide-react';

const PasswordInput = React.forwardRef<HTMLInputElement, any>((props, ref) => {
  const { id, label, status, message, placeholder, ...rest } = props;
  const [show, setShow] = useState(false);

  return (
    <div className="relative w-full">
      <Input
        id={id}
        name={id}
        label={label}
        type={show ? 'text' : 'password'}
        status={status}
        message={message}
        hasIcon={false}
        placeholder={placeholder}
        classNameInput="w-full px-4 py-2 pr-10"
        ref={ref}
        {...rest}
      />
      <button
        type="button"
        onClick={() => setShow((prev) => !prev)}
        className="absolute right-3 top-1/2 -translate-y-1/2 mt-[10px] flex items-center justify-center text-gray-500"
      >
        {show ? <EyeOff size={25} /> : <Eye size={25} />}
      </button>
    </div>
  );
});

PasswordInput.displayName = 'PasswordInput';

export { PasswordInput };
*/
